import styled from 'styled-components';

export const ShareCreditAppQrCodeRoot = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5rem;
    padding: 1.5rem;
    background: ${({ theme }) => theme.tokens?.BaseColorWhite || '#ffffff'};
    box-shadow: 0 0 0.75rem rgba(0, 0, 0, 0.25);
    border-radius: 0.5rem;
`;

export const ShareCreditAppQrCodeImage = styled.div`
    flex: none;
    color: ${({ theme }) => theme.tokens?.SemColorPrimary500 || '#01336B'};
`;

export const ShareCreditAppQrCodeContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: 0;
`;
